import React from 'react';

import ProgrammingMap from 'components/Tvendo/Distribution/Operations/Programming/ProgrammingNew/ProgNewMap';
import ProgrammingNew from 'components/Tvendo/Distribution/Operations/Programming/ProgrammingNew/ProgNew';
import AddOrdersProg from 'components/Tvendo/Distribution/Operations/Programming/ProgrammingNew/AddOrdersProg';
import SplitProg from 'components/Tvendo/Distribution/Operations/Programming/ProgrammingNew/SplitProg';
import { useLocation, useParams } from 'react-router-dom';

export default function () {
  const { id } = useParams();
  const { pathname } = useLocation();
  const divide = pathname.includes('dividir');
  const agregar = pathname.includes('agregar');
  if (divide) {
    return <SplitProg />;
  }

  if (agregar) {
    return <AddOrdersProg />;
  }

  return <>{id === '0' ? <ProgrammingNew /> : <ProgrammingMap />}</>;
}
